import { pluralDays } from '../../../../../../../../../utils/string';

export const formatDuration = (duration: number | undefined): string => {
  return duration ? pluralDays(duration) : '—';
};
